<template>
  <div class="sheet-mask" v-if="show" @click="$emit('close')">
    <div class="sheet" @click.stop>
      <div class="sheet-title">{{ title }}</div>
      <div class="sheet-body">
        <div
          class="sheet-opt"
          v-for="(o, i) in options"
          :key="i"
          :class="{ active: o === value }"
          @click="$emit('select', o)"
        >{{ o }}</div>
      </div>
      <div class="sheet-cancel" @click="$emit('close')">取消</div>
    </div>
  </div>
</template>

<script>
// 通用底部单选操作表：供各表单页「请选择」字段使用
export default {
  name: 'FieldSheet',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: '请选择' },
    options: { type: Array, default: () => [] },
    value: { type: String, default: '' }
  }
}
</script>

<style scoped>
.sheet-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
  display: flex;
  align-items: flex-end;
}
.sheet {
  width: 100%;
  background: #F5F6F7;
  border-radius: calc(24 * var(--w)) calc(24 * var(--w)) 0 0;
  padding-bottom: calc(20 * var(--w));
}
.sheet-title {
  text-align: center;
  font-size: calc(28 * var(--w));
  color: #969799;
  padding: calc(28 * var(--w)) 0;
}
.sheet-body {
  background: #fff;
  max-height: calc(720 * var(--w));
  overflow-y: auto;
}
.sheet-opt {
  text-align: center;
  font-size: calc(32 * var(--w));
  color: #323233;
  padding: calc(32 * var(--w)) 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.sheet-opt:last-child {
  border-bottom: none;
}
.sheet-opt.active {
  color: #2E8CF6;
  font-weight: 500;
}
.sheet-cancel {
  margin-top: calc(16 * var(--w));
  background: #fff;
  text-align: center;
  font-size: calc(34 * var(--w));
  color: #323233;
  padding: calc(30 * var(--w)) 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/FieldSheet.vue